import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/vendor';

class VendorService {
  postVendorInfo = async requestFormData => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestFormData);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating new user');
    }
  };

  editVendorInfo = async requestFormData => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/me`, requestFormData);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing vendor info');
    }
  };

  fetchAllVendorCategories = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/categories/all`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching vendor categories.');
    }
  };

  getClientsForVendor = async (page, search) => {
    try {
      if (!search) {
        search = '';
      }
      const response = await axiosApiClient.get(`${BASE_URL}/clients/?page=${page}&search=${search}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message, maxReached, total, perPage } = response.data;
      return { data, message, maxReached, total, page, perPage };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching vendor clients.');
    }
  };

  getAllClients = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/clients/all`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching all clients.');
    }
  };

  fetchVendorInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { user } = response.data.data;
      return user;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user's info.");
    }
  };

  getClientById = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching client by id.');
    }
  };

  setNoteForClient = async ({ id, note }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client-note/${id}`, { note });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message, weddingVendorId: id };
    } catch (err) {
      throw handleError(err, 'Error occurred while changing client note.');
    }
  };

  changeStatusForClient = async ({ id, status }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client-status/${id}`, { status });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message, weddingVendorId: id };
    } catch (err) {
      throw handleError(err, 'Error occurred while changing client note.');
    }
  };

  setWorkingHours = async workingHours => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/workingHours`, { workingHours });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while setting working hours.');
    }
  };

  getWorkingHours = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/workingHours`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching working hours.');
    }
  };

  acceptClientRequest = async (id, notificationId) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/request-accept/${id}`, { notificationId });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message, weddingVendorId: id, notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while accepting client request.');
    }
  };

  rejectClientRequest = async (id, notificationId) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/request-reject/${id}`, { notificationId });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;

      return { data, message, weddingVendorId: id, notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while rejecting client request.');
    }
  };

  getPaymentIntentsForVendor = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/payments-intents?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message, maxReached, total, perPage } = response.data;
      return { data, message, maxReached, total, page, perPage };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching vendor clients.');
    }
  };
}
const vendorService = new VendorService();

export default vendorService;
